// extracted by css-extract-rspack-plugin
var _1 = "bh";
var _2 = "ur";
var _3 = "e0";
export { _1 as "locationInfoComponent", _2 as "shoppingMallsSectionComponent", _3 as "title" }
